import CustomerRouterLink from './components/RouterLink.vue';
import CustomerSwitch from './components/CustomerSwitch.vue';
import CustomerModel from './models/Customer.js';
import AddressModel from './models/Address.js';

export { CustomerRouterLink, CustomerSwitch, CustomerModel, AddressModel };
